import { render } from "./PlayerSelector.vue?vue&type=template&id=53e16cdc&scoped=true"
import script from "./PlayerSelector.vue?vue&type=script&lang=js"
export * from "./PlayerSelector.vue?vue&type=script&lang=js"

import "./PlayerSelector.vue?vue&type=style&index=0&id=53e16cdc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e16cdc"]])

export default __exports__